import { ActionType, getType } from 'typesafe-actions';

import { DEFAULT_ALERT_CONFIG } from '../enums';
import { AlertConfig, SpotRateDataPoint } from '../types';
import * as actions from './actions';
import {
  PortfolioDataPoint,
  SimulationCubeFilters,
  SimulationMetadata,
} from './types';

export interface FLCashConsumptionState {
  portfolioData: {
    data: PortfolioDataPoint[];
    loading: boolean;
  };
  metadata:           SimulationMetadata | null;
  filters:            SimulationCubeFilters;
  tradeIdList:        number[];
  spotRateData:       Record<string, SpotRateDataPoint[]>;
  alertConfig:        AlertConfig;
  selectedDate:       string;
  simulationProgress: number | null;
}

const initialState: FLCashConsumptionState = {
  portfolioData: {
    data:    [],
    loading: false,
  },
  metadata:           null,
  filters:            {},
  tradeIdList:        [],
  spotRateData:       {},
  alertConfig:        DEFAULT_ALERT_CONFIG,
  selectedDate:       '',
  simulationProgress: null,
};

const flCashConsumptionReducer = (
  state: FLCashConsumptionState = initialState,
  action: ActionType<typeof actions>,
): FLCashConsumptionState => {
  switch (action.type) {
    case getType(actions.setSelectedDate):
      return { ...state, selectedDate: action.payload };

    case getType(actions.setAlertConfig):
      return { ...state, alertConfig: action.payload };

    case getType(actions.setSimulationProgress):
      return { ...state, simulationProgress: action.payload };

    case getType(actions.fetchSimulationCube.request):
      return {
        ...state,
        portfolioData: { ...state.portfolioData, loading: true },
        filters:       action.payload ?? {},
      };

    case getType(actions.fetchSimulationCube.success):
      return {
        ...state,
        portfolioData:      { data: action.payload.portfolioData, loading: false },
        metadata:           action.payload.metadata,
        tradeIdList:        action.payload.tradeIdList,
        spotRateData:       action.payload.spotRateData,
        simulationProgress: null,
      };

    case getType(actions.fetchSimulationCube.failure):
      return {
        ...state,
        portfolioData:      { ...state.portfolioData, loading: false },
        simulationProgress: null,
      };

    default:
      return state;
  }
};

export default flCashConsumptionReducer;
